// extracted by mini-css-extract-plugin
export default {"principalButton":"SuggestPrincipalButton_principalButton__UoiVT"};